//#region src/constants/property-identifiers.ts
var e = new Set([
	"team.id",
	"assigned_team_id",
	"$admin_participant_ids",
	"team_assignee_id",
	"comment_team_assignee_id",
	"team"
]), t = new Set([
	"admin_participant_ids",
	"admin_assignee_id",
	"$admin_participant_ids",
	"teammate_id",
	"conversation_rating.admin_id",
	"comment_admin_assignee_id",
	"teammate_handled",
	"first_reply_teammate_id",
	"attributed_to_admin_id",
	"last_human_authored_closer_teammate_id",
	"first_human_authored_closer_teammate_id",
	"teammate_closed",
	"mentions",
	"admin_id",
	"call_admin_ids",
	"teammate",
	"assigned_teammate_id",
	"teammate_assignee_at_close",
	"teammate.id",
	"rated_actor_id.human_id",
	"rating_participants.human_ids"
]);
//#endregion
export { t as TEAMMATE_PROPERTY_IDENTIFIERS, e as TEAM_PROPERTY_IDENTIFIERS };
